const GET_VALIDATE_ASSET_INVENTORY_RESET = 'GET_VALIDATE_ASSET_INVENTORY_RESET'
const SET_VALIDATE_ASSET_INVENTORY_RESET = 'SET_VALIDATE_ASSET_INVENTORY_RESET'

const GET_SAVE_ASSET_INVENTORY = 'GET_SAVE_ASSET_INVENTORY'
const SET_SAVE_ASSET_INVENTORY = 'SET_SAVE_ASSET_INVENTORY'

export {
    GET_VALIDATE_ASSET_INVENTORY_RESET,
    SET_VALIDATE_ASSET_INVENTORY_RESET,
    GET_SAVE_ASSET_INVENTORY,
    SET_SAVE_ASSET_INVENTORY
}